<template>
    <div>
        <div class="w-full p-4 bg-grey-lighter flex" @click="item.open = ! item.open">
            <div>
                <span v-html="item.label"></span>
            </div>
            <div class="flex-grow text-right">
                <span class="font-thin italic text-sm" v-html="item.type"></span>
                <span class="ml-2 text-lg cursor-pointer" v-if="item.label != 'Quick Links' && item.label != 'About Us' && item.label != 'Support' && item.label != 'MOT & Servicing'" @click="deleteItem()">
                    <app-icon icon="times" class="text-red" />
                </span>
                <span class="ml-2 text-lg cursor-pointer" @click="item.open = ! item.open">
                    <app-icon v-if="item.open" icon="angle-down" />
                    <app-icon v-else icon="angle-right" />
                </span>
            </div>
        </div>
        <div v-if="item.open" class="bg-white p-6 border border-grey-lighter text-sm">
            <component
                :is="component"
                :item="item"
                :locales="locales"
            />
        </div>
    </div>
</template>
<script>
    import MenuPage from '@/components/menu/Page.vue';
    import MenuItem from '@/components/menu/Item.vue';
    import MenuCta from '@/components/menu/Cta.vue';

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            locales: {
                type: Array,
                required: true
            }
        },

        components: {
            'app-menu-page': MenuPage,
            'app-menu-item': MenuItem,
            'app-menu-cta': MenuCta
        },

        computed: {
            component() {
                if(this.item.type == 'Page') {
                    return 'app-menu-page';
                } else if(this.item.type == 'CTA') {
                    return 'app-menu-cta';
                }

                return 'app-menu-item';
            }
        },

        methods: {
            deleteItem() {
                this.$emit('delete')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/menu/Bar.vue